import React, { Component } from 'react';
import PropTypes from "prop-types";
import Button from "../../../../../components/UI/Button";
import ModalOverlay from "../../../../../components/UI/ModalOverlay";
import theme from '../../../../../Theme/theme';
import './style.css'

const THANKS_TEXT = "Thanks for using FlexIt at"
const USE_NOW_TEXT = "USE NOW"
const DISCARD_OFFER_TEXT = "DISCARD OFFER"
const PROMOTION_BANNER = require('../../../../../assets/images/promotional_banner.png');

class PromotionalPreview extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <ModalOverlay
                modalStyle={style.modalStyle}
                bodyStyle={style.modalBody}
                underLayerStyle={style.underLayer}
                noTitle={true}
                close={this.props.close}
            >
                <div style={style.thanksText}>{THANKS_TEXT + " " + this.props.gymName + "!"}</div>
                <div className="Banner" style={{ backgroundImage: `url(${PROMOTION_BANNER})` }}>
                    <div style={style.title}>{this.props.title}</div>
                </div>
                <div style={style.productDetailsContainer}>
                    <div style={style.description}>{this.props.description}</div>
                    <div style={style.productName}>{this.props.productName}</div>
                </div>
                <Button style={style.useNowButton} type="primary">{USE_NOW_TEXT}</Button>
                <Button style={{ ...style.useNowButton, ...style.discardButton }} type="primary">{DISCARD_OFFER_TEXT}</Button>
            </ModalOverlay>
        )
    }
}

PromotionalPreview.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired,
    gymName: PropTypes.string.isRequired
};

const style = {
    modalStyle: {
        backgroundColor: theme.color.white,
        borderRadius: 3
    },
    underLayer: {
        backgroundColor: theme.color.shadowColor
    },
    modalBody: {
        width: 350,
        borderRadius: "0px 0px 15px 15px",
        backgroundColor: theme.color.transparent
    },
    useNowButton: {
        width: "70%",
        height: 45,
        fontSize: 16,
        letterSpacing: 3.32,
        lineHeight: "45px",
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        color: theme.color.white,
        backgroundColor: theme.color.primaryBlue,
        borderRadius: 5,
        borderWidth: 0
    },
    discardButton: {
        background: theme.color.tableSeparatorGrey,
        marginTop: 15,
        marginBottom: 50
    },
    thanksText: {
        marginTop: 50,
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        color: theme.color.thickGrey,
        fontSize: 15,
        letterSpacing: 3.11,
        marginLeft: 20,
        marginRight: 20
    },
    title: {
        height: "70%",
        width: "80%",
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 20,
        paddingBottom: 8,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.normal,
        fontStyle: theme.fontWeight.italic,
        color: theme.color.white,
        fontSize: 20,
        whiteSpace: "normal",
        overflow: "scroll"
    },
    productDetailsContainer: {
        padding: 30,
        marginBottom: 40,
        marginTop: 40,
        marginLeft: 30,
        marginRight: 30,
        borderStyle: "dashed",
        borderWidth: 2,
        borderColor: theme.color.primaryBlue
    },
    description: {
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        color: theme.color.primaryBlue,
        overflowWrap: "break-word",
        fontSize: 40,
        letterSpacing: 1.43
    },
    productName: {
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.regular,
        color: theme.color.thickGrey,
        overflowWrap: "break-word",
        fontSize: 15,
        letterSpacing: 0.54,
        marginTop: 8
    }
};

export default PromotionalPreview;

